import { buildLimitedPrivateApi } from './limitPrivateAPI';
export class LimitedPrivateAPI {
    constructor(privateAPI) {
        this.privateAPI = privateAPI;
    }
    build(config) {
        return buildLimitedPrivateApi(this.privateAPI, config);
    }
}
//# sourceMappingURL=LimitedPrivateAPI.js.map